// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__erh8N","body":"style_body__rl7KB","linkContainer":"style_linkContainer__0RUGt","footer":"style_footer__oHerp"};